<template>
  <div>
    <div class="filter-container">
      <el-input size="medium" placeholder="NO." v-model="search" clearable debounce @input="changeInput()"
        :style="{ width: '300px', marginRight: '20px' }" />
      <el-button size="medium" type="primary" @click="handleSearch()">Search</el-button>
    </div>

    <el-table :data="list.slice(
      (listQuery.page - 1) * listQuery.limit,
      listQuery.page * listQuery.limit
    )
      " v-loading="listLoading" style="width: 100%;" :cell-style="{ textAlign: 'center' }"
      :header-cell-style="{ textAlign: 'center' }">
      <el-table-column prop="vehicle_plate" label="No."></el-table-column>
      
      <el-table-column label="Bind">
        <template slot-scope="scope">
          <div v-if="!scope.row.bind">
            <i class="el-icon-link editVehicle" @click="handleBind(scope.row)" > </i>
          </div>
          
        </template>
      </el-table-column>
      <el-table-column label="Tyre Pressure">
        <template slot-scope="{ row, $index }">
          <div v-if="row.bind">
            <i class="el-icon-view editVehicle" @click="handleView(row)"> </i>
          </div>
          
        </template>
      </el-table-column>
      <el-table-column label="Action">
        <template slot="header" slot-scope="scope">
          <i class="el-icon-circle-plus addVehicle" @click="handleCreate"> </i>
        </template>

        <template slot-scope="{ row, $index }">
          <!-- <i class="el-icon-edit editVehicle" @click="handleUpdate(row)"> </i> -->
          <el-popconfirm title="Do you want to delete the trailer?" confirm-button-text="Yes" cancel-button-text="No"
            @onConfirm="handleDelete(row)">
            <i slot="reference" class="el-icon-delete delVehicle"> </i>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <div class="ls-page">
      <pagination v-show="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit"
        @pagination="getDataList" />
    </div>

    <el-dialog :title="dialogStatus" :visible.sync="dialogFormVisible" @close="resetForm" width="40%">
      <el-form ref="vehicleForm" :rules="rules" :model="temp" label-position="left" label-width="100px" class="vehicleForm">
        <el-form-item label="No." prop="vehicle_plate">
          <el-input v-model="temp.vehicle_plate" :disabled="dialogStatus === 'Update'" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">
          Cancel
        </el-button>
        <el-button type="primary" @click="dialogStatus === 'Create' ? createData() : updateData()">
          Next
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
import Pagination from "components/pagination";

import { getTrailerList, createTrailer, updateTrailer, deleteTrailer } from "network/trailer";

export default {
  name: "Trailer",
  components: { Pagination },
  data() {
    return {
      search: "",
      type: "",
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 10,
      },
      list: [],
      temp: {
        type: "Trailer",
        vehicle_plate: "",
      },
      dialogFormVisible: false,
      dialogStatus: "",
      rules: {
        vehicle_plate: [
          {
            required: true,
            message: "Please input NO.",
            trigger: "blur",
          },
        ]
      },
      moment: moment,
    };
  },
  created() {
    this.getDataList();
  },
  methods: {
    getDataList() {
      this.listLoading = false;
      getTrailerList()
        .then((data) => {
          this.listLoading = false;

          this.list = data.data;
          this.total = this.list.length;
        })
        .catch((err) => {
          this.$message.error("Interface error:get_trailer_list");
        });
    },
    changeInput() {
      if (this.search === "") {
        this.getDataList();
      }
    },
    handleSearch() {
      this.listLoading = false;
      getTrailerList()
        .then((data) => {
          if (data.status === 200) {
            this.listLoading = false;

            this.list = data.data;
            this.total = this.list.length;
          }
        })
        .then(() => {
          let newList = [];
          newList = this.list.filter((item, index) => {
            const vehicle_plate =
              item.vehicle_plate.toUpperCase().indexOf(this.search.toUpperCase()) !==
              -1;

            if (vehicle_plate) {
              return true;
            }
          });

          this.list = newList;
          this.total = newList.length;
        })
        .catch((err) => {
          this.$message.error("Interface error: get_trailer_list");
        });
    },
    resetForm() {
      this.temp = {
        type: "Trailer",
        vehicle_plate: ""
      };
      this.$nextTick(() => {
        if (this.$refs["vehicleForm"]) {
          this.$refs["vehicleForm"].clearValidate();
        }
      });
    },
    handleCreate() {
      this.dialogStatus = "Create";
      this.dialogFormVisible = true;
    },
    createData() {
      this.$refs["vehicleForm"].validate((valid) => {
        if (valid) {
          createTrailer(this.temp).then((data) => {
            console.log(data);
            if (data.status === 201) {
              this.getDataList();

              this.dialogFormVisible = false;

              this.$message({
                message: "Created Successfully.",
                type: "success",
              });

              this.handleBind(data.data)
            }
          })
          .catch(err => {
              this.$message.error("Interface error: this No. already exists");
            })
        }
      });
    },
    handleUpdate(row) {
      this.temp = Object.assign({}, row); // copy obj
      this.dialogStatus = "Update";
      this.dialogFormVisible = true;
    },
    updateData() {
      this.$refs["vehicleForm"].validate((valid) => {
        if (valid) {
          const tempData = Object.assign({}, this.temp);
          updateTrailer(tempData.id, tempData).then((data) => {
            if (data.status === 200) {
              this.getDataList();

              this.dialogFormVisible = false;

              this.$message({
                message: "Updated Successfully.",
                type: "success",
              });
            }
          });
        }
      });
    },
    handleDelete(row) {
      deleteTrailer(row.id).then((data) => {
        if (data.status === 204) {
          this.getDataList();

          this.$message({
            message: "Delete Successfully.",
            type: "success",
          });
        }
      })
      .catch(err => {
        this.$message.error("Interface error: delete");
      })
    },
    handleBind(row) {
      this.$router.push({
        path: '/bind_trailer',
        query: {plate: row.vehicle_plate, vehicle_id:row.id}
      })
    },
    handleView(row) {
      this.$router.push({
        path: '/detail_trailer',
        query: {plate: row.vehicle_plate, vehicle_id:row.id}
      })
    },
    handleMap(row) {
      this.$router.push({
        path: '/map',
        query: {plate: row.vehicle_plate, vehicle_id:row.id}
      })
    }
  },
};
</script>

<style scoped>
.ls-page {
  float: right;
}

.addVehicle {
  font-size: 32px;
  cursor: pointer;
}

.editVehicle {
  font-size: 28px;
  cursor: pointer;
}

.delVehicle {
  /* margin-left: 10px; */
  font-size: 28px;
  cursor: pointer;
  color: red;
}

.vehicleForm .el-select {
  width: 100%;
}
</style>
